import manAfter from "../assets/images/man_after.png";
import manBefore from "../assets/images/man_before.png";
import womanAfter from "../assets/images/woman_after.png";
import womanBefore from "../assets/images/woman_before.png";

export function MarketingPage() {
	return (
		<article className="marketing-page">
			<section className="marketing-page__hero">
				<div className="marketing-page__hero-copy">
					<span className="marketing-page__badge">QuickID</span>
					<h1 className="marketing-page__title">
						AIでスーツ合成、証明写真風を手早く
					</h1>
					<div className="marketing-page__tagline">
						<p>自撮りから“それっぽい”ビジネス写真。</p>
						<p>プロフィール用の証明写真風をAIで。</p>
					</div>
					<p className="marketing-page__lead">
						自撮りから、履歴書やプロフィールに使いやすい「証明写真風」をAIでサッと作成。服装（スーツ／ブラウス）や背景色も選べます。※公的な本人確認・身分証用途には使用できません。
					</p>
					<div className="marketing-page__actions">
						<a
							className="cta"
							href="https://apps.apple.com/app/id6753057048"
							target="_blank"
							rel="noreferrer"
						>
							今すぐインストール
						</a>
						<a className="secondary-link" href="mailto:support@monello.jp">
							お問い合わせ
						</a>
					</div>
				</div>
				<div className="marketing-page__hero-visual">
					<div className="marketing-page__comparison-card">
						<h2 className="marketing-page__comparison-title">
							自撮りが1分で証明写真風に
						</h2>
						<div className="marketing-page__comparison-grid">
							<figure className="marketing-page__comparison">
								<img src={manBefore} alt="QuickIDで加工前の男性の自撮り写真" />
								<figcaption>Before</figcaption>
							</figure>
							<figure className="marketing-page__comparison marketing-page__comparison--after">
								<img
									src={manAfter}
									alt="QuickIDで証明写真風に整えた男性の写真"
								/>
								<figcaption>After</figcaption>
							</figure>
							<figure className="marketing-page__comparison">
								<img
									src={womanBefore}
									alt="QuickIDで加工前の女性の自撮り写真"
								/>
								<figcaption>Before</figcaption>
							</figure>
							<figure className="marketing-page__comparison marketing-page__comparison--after">
								<img
									src={womanAfter}
									alt="QuickIDで証明写真風に整えた女性の写真"
								/>
								<figcaption>After</figcaption>
							</figure>
						</div>
					</div>
				</div>
			</section>

			<section className="marketing-page__description">
				<p>
					QuickIDは、自撮りや端末内の写真から、履歴書・会社プロフィール・名刺・SNSなどに使いやすい
					<strong>「証明写真風」</strong>
					の画像をAIで作成するアプリです。服装（スーツ／シャツ／ブラウス）や背景色を選んで、1分ほどで自然な仕上がりに。撮影が苦手でも、手元の写真から手早く整った一枚が作れます。
				</p>
			</section>

			<section className="marketing-page__section">
				<h2>主な機能</h2>
				<ul>
					<li>
						AI合成で「証明写真風」：顔の向き・明るさを最適化して自然に仕上げます
					</li>
					<li>
						服装の選択：スーツ上下／シャツ／ブラウスなど（Premiumで種類拡張）
					</li>
					<li>背景色の選択：白／青系／グレー系など（Premiumで色数拡張）</li>
					<li>簡単ガイド：位置合わせやトリミングをアプリがサポート</li>
					<li>端末保存：生成結果は端末に保存。そのまま共有や印刷に</li>
				</ul>
			</section>

			<section className="marketing-page__section">
				<h2>想定用途</h2>
				<ul>
					<li>履歴書・エントリーシート</li>
					<li>会社プロフィール／名刺</li>
					<li>SNS・ビジネスプロフィール</li>
				</ul>
				<p className="marketing-page__note">
					※パスポート、マイナンバーカード、運転免許証などの公的な本人確認・身分証用途には使用できません。
				</p>
			</section>

			<section className="marketing-page__section marketing-page__section--steps">
				<h2>使い方</h2>
				<ol>
					<li>写真を撮影／選択</li>
					<li>服装と背景色を選ぶ</li>
					<li>プレビューを確認して保存</li>
				</ol>
			</section>

			<section className="marketing-page__section marketing-page__section--pricing">
				<h2>料金</h2>
				<div className="marketing-page__pricing-grid">
					<div className="marketing-page__pricing-card">
						<h3>Basic</h3>
						<p className="marketing-page__price">週額300円</p>
						<ul>
							<li>標準の服装・背景色</li>
							<li>一般的な生成上限</li>
						</ul>
					</div>
					<div className="marketing-page__pricing-card marketing-page__pricing-card--premium">
						<h3>Premium</h3>
						<p className="marketing-page__price">週額780円</p>
						<ul>
							<li>生成上限アップ</li>
							<li>服装・背景色の追加オプション</li>
						</ul>
					</div>
				</div>
				<p className="marketing-page__note">
					※自動更新のアプリ内サブスクリプション。解約はApp
					Storeのサブスクリプション管理から行えます。
				</p>
			</section>
		</article>
	);
}

export default MarketingPage;
